module.exports = __webpack_public_path__ + "img/email.9e6511a0.png";